<template>
  <div>
    <Navigation/>
    <div class="bg_box">
      <div class="noneBox"></div>
      <div class="box">
        <p class="back" @click="$router.push('/wordNav')">返回</p>
        <div class="ct_box flex">
          <div class="form_upload_box">
            <ai_title ai_title="“智能生成”_AI声明生成"/>
            <select_model @getModelStyle="getModelStyle"></select_model>
            <div class="generated_title_box">

              <p class="from_title_new">生成声明</p>
              <ai_switch :select_version="form.select_version" tab1_name="简易版" tab2_name="正式版"
                         @select_versionShow="select_versionShow"/>
            </div>

            <div class="transparent_box">

              <div v-if="form.select_version == '2'">
                <div class="form_ct flex">
                  <p class="upLoad_text">发文机关名称：</p>
                  <div class="upload_box">
                    <el-input v-model="form.institution_name"
                              placeholder="请录入发文机关名称。如：××××有限责任公司"></el-input>
                  </div>
                </div>
              </div>
              <div class="form_ct flex">
                <p class="upLoad_text">声明事由：</p>
                <div class="upload_box">
                  <el-input v-model="form.statement_reason" placeholder="请简述声明事由，如:遗失声明"></el-input>
                </div>
              </div>
              <div class="form_ct flex">
                <p class="upLoad_text">声明内容：</p>
                <div class="upload_box">
                  <el-input v-model="form.statement_content"
                            placeholder="简明扼要地写明发表声明的原因，表明对有关事件的立场、态度"></el-input>
                </div>
              </div>
              <div class="form_ct flex">
                <p class="upLoad_text">核心表述词：</p>
                <div class="upload_box">
                  <el-input resize="none" show-word-limit type="textarea" :rows="3"
                            v-model="form.statement_keyword"
                            placeholder="请对结尾进行核心表述词录入，如：署名、时间"></el-input>
                </div>
              </div>
              <ai_button_file_data ref="ai_button_file_data" @file_data="file_data"/>
              <ai_text_content :contentData="contentData"/>
            </div>

          </div>
          <wordNav/>
          <aiNum title="计费规则：1000tokens = 0.9元，" text="1000tokens在700-750字左右" :visible="aiNumShow"
                 @close="aiNumShow = false" @postData="postData"/>
          <aiPoup :visible="aiPoupShow" @close="aiPoupShow = false"/>
        </div>
      </div>
    </div>
    <footerBot/>
  </div>
</template>

<script>
import wordNav from '@/components/wordNav.vue'
import ai_switch from '@/components/ai_switch.vue'
import ai_select from '@/components/ai_select'
import ai_title from '@/components/ai_title'
import ai_text_content from '@/components/ai_text_content'
import ai_button_file_data from '@/components/ai_button_file_data'
import select_model from "@/components/select_model.vue";

export default {
  mounted() {
    this.getUserInfo()
  },
  components: {
    select_model,
    ai_title,
    ai_switch,
    wordNav,
    ai_select,
    ai_text_content,
    ai_button_file_data
  },
  data() {
    return {
      // 模型选择
      model_style: 1,
      form: {
        select_version: '1',
        statement_reason: '',  //# 声明事由
        statement_content: '', //# 声明内容
        institution_name: '', //#发文机关名称
        statement_keyword: '',  //# 核心表述词
      },

      contentData: {}, //内容
      aiNumShow: false,
      aiPoupShow: false,

    }
  },
  methods: {
    getModelStyle(data) {
      this.model_style = data
    },
    select_versionShow(id) {
      this.form = {
        select_version: id,
        statement_reason: '',  //# 声明事由
        statement_content: '', //# 声明内容
        institution_name: '', //#发文机关名称
        statement_keyword: '',  //# 核心表述词
      }
    },
    // 获取用户信息
    getUserInfo() {
      let $user_info = JSON.parse(localStorage.getItem('user_info'))
      if ($user_info) {
        this.curlGet('/api/user/info').then((res) => {
          if (res.data.code) {
            this.$user_info = res.data.data
            this.$util.setLocalStorage('user_info', res.data.data) // 写入local storage
          }
        })
      }
    },
    file_data() {
      if (this.model_style === 1) {
        this.postData()
        return
      }
      if (this.$user_info.money <= 0) {
        this.aiPoupShow = true
      } else {
        this.aiNumShow = true
      }

    },
    postData() {
      this.aiNumShow = false
      this.$refs.ai_button_file_data.loading_show()
      let data = {}
      data.select_version = this.form.select_version
      data.mobile = this.$user_info.mobile
      data.statement_reason = this.form.statement_reason
      data.statement_content = this.form.statement_content
      data.statement_keyword = this.form.statement_keyword
      if (this.form.select_version == '2') {
        data.institution_name = this.form.institution_name
      }
      data.model_style = this.model_style
      this.curlPost('/file/create_statement', data).then(res => {
        this.$refs.ai_button_file_data.loading_show()
        if (res.data.code) {
          this.contentData = res.data.data
          // 扣费
          this.curlPost('/api/users/money_log/spend', {
            ai_id: res.data.data.id,
            amount: res.data.data.money,
          }).then(res => {
            if (res.data.code) {
              this.getUserInfo()
            }
          })
        } else {
          this.$message.error(res.data.msg);
        }
      })
    }
  },
}
</script>

<style lang=scss scoped>
@use '@/scss/ai'
</style>